export default function StatCard({ icon: Icon, value, label, color, children }) {
  const colorMap = {
    brand: "bg-brand-light text-brand",
    green: "bg-emerald-50 text-emerald-500",
    blue: "bg-blue-50 text-blue-500",
    amber: "bg-amber-50 text-amber-500",
  };

  return (
    <div className="bg-white rounded-2xl p-5 border border-gray-200 hover:shadow-md hover:-translate-y-0.5 transition-all">
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 ${colorMap[color]}`}>
        <Icon size={20} />
      </div>
      <div className="text-2xl font-bold text-gray-900">{value}</div>
      <div className="text-xs text-gray-500 mt-0.5">{label}</div>
      {children}
    </div>
  );
}
